import React from 'react'

export const LoaderSuspense = () => {
  return (
    <div
      id="loader-suspense"
      className="loading-container align-items-center justify-content-center"
    >
      <div className="loading-spinner-container">
        <div className="loader-spinner">
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
        </div>
      </div>
    </div>
  )
}

const Loader = () => {
  return (
    <div
      id="loader"
      className="loading-container align-items-center justify-content-center"
      style={{ display: 'none' }}
    >
      <div className="loading-spinner-container">
        <div className="loader-spinner">
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
          <div>
            <div />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Loader

export const showLoader = (loading) => {
  let loader = document.getElementById('loader')
  if (loader && loading === true) {
    loader.classList.add('d-flex')
  } else {
    loader.classList.remove('d-flex')
  }
}
